<script setup>
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';

defineProps({
  copies: { type: Array, default: () => [] },
  errors: { type: Object, default: () => ({}) },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(['update']);
const { t } = useI18n();
</script>

<template>
  <div class="grid gap-4 sm:grid-cols-2">
    <div
      v-for="(copy, index) in copies"
      :key="copy.id || index"
      class="grid gap-3"
    >
      <p class="text-xs font-bold uppercase tracking-wide text-lais-text-muted">
        {{ t('SALES.DELIVERY.EMAILS.COPY_ITEM', { index: index + 1 }) }}
      </p>
      <LaisField
        :label="t('SALES.DELIVERY.EMAILS.EDITOR.NAME')"
        :error="errors[`copy_${index}`]"
      >
        <input
          :value="copy.name"
          class="h-10 w-full rounded-lais-sm border border-lais-border bg-white px-3 text-sm"
          :disabled="disabled"
          @input="emit('update', index, 'name', $event.target.value)"
        />
      </LaisField>
      <LaisField
        :label="t('SALES.DELIVERY.EMAILS.EDITOR.EMAIL')"
        :error="errors[`copy_${index}`]"
        required
      >
        <input
          :value="copy.email"
          type="email"
          class="h-10 w-full rounded-lais-sm border border-lais-border bg-white px-3 text-sm"
          :disabled="disabled"
          @input="emit('update', index, 'email', $event.target.value)"
        />
      </LaisField>
    </div>
  </div>
</template>
